import TestResults from '@/components/test/test-results';
import { useCourses } from '@/providers';

export default function ResultsTab() {
  const { selectedCourse } = useCourses();

  if (selectedCourse?.type !== 'Test') return null;

  return <TestResults />;
}
